import { useCallback, useState } from "react";
import { useRolPatch } from "../../../fnx/rol/rolPatch";
import { useDispatch } from "react-redux";
import { rolPatchClearData } from "../../../store/rol/actions";
export var useAssignPermissionsToRol = function (_a) {
    var rolId = _a.rolId, rolName = _a.rolName, rolDescription = _a.rolDescription;
    var dispatch = useDispatch();
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState(undefined), bodyData = _c[0], setBodyData = _c[1];
    var _d = useRolPatch(trigger, bodyData, rolId), responseRolPatch = _d.responseRolPatch, errorRolPatch = _d.errorRolPatch, loadingRolPatch = _d.loadingRolPatch;
    /**
     * Maneja la asignación de permisos al rol
     */
    var handleAssignPermissions = useCallback(function (rolId, permissions) {
        setBodyData({
            name: rolName,
            description: rolDescription,
            permissions: permissions,
        });
        setTrigger(true);
    }, [rolName, rolDescription]);
    /**
     * Resetea los triggers después de una operación
     */
    var resetTrigger = useCallback(function () {
        setTrigger(false);
        setBodyData(undefined);
        dispatch(rolPatchClearData());
    }, []);
    return {
        handleAssignPermissions: handleAssignPermissions,
        resetTrigger: resetTrigger,
        loading: loadingRolPatch,
        error: errorRolPatch,
        response: responseRolPatch,
    };
};
